import { combineReducers } from 'redux';
import { userReducer } from './User/UserReducer';
import { patientReducer } from './Patient/PatientReducer';
import { generalReducer } from './General/GeneralReducer';
import { laboratoryReducer } from './Laboratory/LaboratoryReducer';
import { formsReducer } from './Forms/FormsReducer';
import { reportsReducer } from './Reports/ReportsReducer';
import { drugReducer } from './Drug/DrugReducer';
import { appointmentReducer } from './Appointment/AppointmentReducer';
import { entityReportReducer } from './EntityReport/EntityReportReducer';
import { dynamicFormsReducer } from './DynamicForms/DynamicFormsReducer';
import loadingReducer from './Loading/LoadingReducer';
import { statisticsReducer } from './Statistics/StatisticsReducer';
import { searchReducer } from './Search/SearchReducer';
import { clinicReducer } from './Clinic/ClinicReducer';

export const combinedReducer = combineReducers({
    appointment: appointmentReducer,
    user: userReducer,
    patient: patientReducer,
    general: generalReducer,
    laboratory: laboratoryReducer,
    forms: formsReducer,
    reports: reportsReducer,
    drug: drugReducer,
    entityReport: entityReportReducer,
    dynamicForms: dynamicFormsReducer,
    statistics: statisticsReducer,
    ui: combineReducers({ loading: loadingReducer }),
    search: searchReducer,
    clinic: clinicReducer
});

// this section is to reset the store when clinic has changed
const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE') {
        if (state) {
            state = {
                patient: undefined,
                user: state.user,
                appointment: undefined,
                general: undefined,
                laboratory: undefined,
                forms: undefined,
                reports: undefined,
                drug: undefined,
                entityReport: undefined,
                dynamicForms: undefined,
                statistics: undefined,
                search: undefined
            };
        }
    }
    return combinedReducer(state, action);
};
export { rootReducer };
